import { Container, Typography } from "@mui/material"
import { Box } from "@mui/system"
import Partner from './partnerImage.png'
export default () => {
    const sectionHeading = 'PARTNERSHIP'
    return (
        <Box pt={15} id="partnership">
            <Container sx={{ zIndex: '1' }}>
            <Box sx={{ position: 'relative', textAlign: 'center' }} mb={10}>
                        <Box > <span className="textStroke"><Typography color='white' fontSize={{ xs: '31px', sm: '50px', md: '74px' }} sx={{ letterSpacing: '0.12em' }}>
                            {sectionHeading}
                        </Typography></span></Box>
                        <Box sx={{ position: 'absolute', top: '10%', right: 0, left: 0, margin: 'auto' }}>
                            <Typography color='white' fontSize={{ xs: '25px', sm: '40px', md: '64px' }} sx={{ letterSpacing: '0.12em' }}>
                                {sectionHeading}
                            </Typography>
                        </Box>
                    </Box>
            </Container>
            <Box maxWidth='xl' margin='auto'>
                <img src={Partner} alt={Partner} width="100%" />
            </Box>
        </Box>
    )
}
